import React from 'react';
import { Link } from 'react-router-dom';
import { Field, Spinner } from '../../components/Common';
import { validationAccount } from '../../api/api';

export class ReactivationBenefPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            code: '',
            validationCode: false,
            errorMessage: '',
            spinner: 'inactive'
        }
    }

    handleOnChange(key, e) {
        const value = e.target.value;
        this.setState(() => ({ [key]: value }));
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const data = {
            user: this.props.match.params.user,
            code: this.state.code
        }
        this.setState({ spinner: 'active' });
        validationAccount(data).then((response) => {
            setTimeout(() => { this.setState({ spinner: 'inactive' }) }, 500);
                this.setState({ validationCode: true, errorMessage: '' });
        }, error => {
            this.setState({ errorMessage: 'Le code de validation est incorrect.' });
            setTimeout(() => { this.setState({ spinner: 'inactive' }) }, 500);
            console.log(error);
        })
    };

    render() {
        return (
            <div className="sign-on-main">
                <div className="page-background"></div>
                <div className="container sign-on-container _validation">
                    <div className="bloc-form">
                        <div className="bloc-form_container validation">
                            <h2>Déblocage de votre compte de chargé de mémoire</h2>
                            {!this.state.validationCode ?
                                <form onSubmit={this.handleSubmit}>
                                    <Field
                                        label="Merci d'entrer votre code de validation :"
                                        type="text"
                                       // placeholder="123456"
                                        _className="form-control "
                                        value={this.state.code}
                                        onChange={this.handleOnChange.bind(this, "code")}
                                    />
                                    <div className="button-container">
                                        <button type="submit" className={`btn btn-primary btn-lg spinner-${this.state.spinner}`} disabled={!this.state.code} >
                                            <span>Valider</span>
                                            <Spinner status={this.state.spinner} />
                                        </button>
                                    </div>
                                </form> :
                                <div className="bloc-from_success">
                                    <img src='/images/yes.png' alt="image" />
                                    <p className="validation-txt">
                                        Votre compte est débloqué et vous pouvez maintenant vous connecter.                                        
                                    </p>
                                    <Link to="/charge-memoire-login"><button type="button" className="btn btn-primary btn-lg">Me connecter</button></Link>
                                </div>
                            }
                        </div>
                        <div className="bloc-form_error">
                            {this.state.errorMessage &&
                                <div className="alert alert-danger single-line" role="alert">{this.state.errorMessage}</div>
                            }
                        </div>
                    </div>
                    <div className="signon-container">
                        <div className="col-sm-5 text-bloc">
                            <h2>Compte bloqué ?</h2>
                            <p className>Pour débloquer votre compte, il est nécessaire de saisir le code d'activation reçu par mail.</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ReactivationBenefPage;




// WEBPACK FOOTER //
// ./src/components/ReactivationPage/ReactivationChargePage.js